import React, { FC, useState } from 'react';
import { useLayer } from '@/layers/useLayer.tsx';
import * as Sentry from '@sentry/browser';
import { useZxing } from 'react-zxing';
import { isNil } from 'ramda';
import { ICONS } from '@/Icons';

interface QrScannerProps {
  onScannerChange: (detectedCode: string) => void;
}

export const QrScanner: FC<QrScannerProps> = ({ onScannerChange }) => {
  const { showLayer } = useLayer();
  const [facingMode, setFacingMode] = useState('environment');

  const showCameraNotAllowedLayer = (err: unknown) => {
    console.error(err);
    Sentry.captureException(err);
    showLayer({ ref: '@cameraNotAllowed' });
  };

  const { ref } = useZxing({
    onDecodeResult: (result) => {
      if (!isNil(result.getText())) {
        onScannerChange(result.getText());
      }
    },
    onError: showCameraNotAllowedLayer,
    constraints: { video: { facingMode }, audio: false },
  });

  return (
    <div className="viewport">
      <video ref={ref} />
      <button
        onClick={() => {
          setFacingMode(facingMode === 'user' ? 'environment' : 'user');
        }}
      >
        <i className={ICONS['rotate']} />
      </button>
    </div>
  );
};
